import Vue from "vue";
import QueryString from "./parser/QueryString.js";

export default class EventSourceService {
    url: string;
    eventBus: Vue;
    eventSource: EventSource;
    queues: Array<any>;

    constructor(url: string, eventBus: Vue) {
        this.url = url;
        this.eventBus = eventBus;
        this.queues = [];
    }

    init() {
        let queryObject = {
            queues: JSON.stringify(this.queues)
        };
        let query = QueryString.encodeWithBracket(queryObject);

        this.connect(query);

        let scope = this;
        this.eventSource.onmessage = function(event) {
            let res = JSON.parse(event.data);
            scope.emitOnMessageEvent(res);
        }

        this.eventSource.onerror = function(event) {
            console.error("EventSourceService failed:", event);
        }

        return this.eventSource;
    }

    addQueue(name: String, params: Object) {
        let queue = this.findQueueByName(name);

        if (0 < queue.length) {
            queue[0].numberOfParticipants++;

            return;
        }

        this.queues.push({name: name, params: params, numberOfParticipants: 1});
        this.init();
    }

    removeQueue(name: String) {
        let queue = this.findQueueByName(name);

        if (0 === queue.length) {
            return;
        }

        queue[0].numberOfParticipants--;

        if (0 < queue[0].numberOfParticipants) {
            return;
        }

        this.queues = this.queues.filter(q => q.name !== name);

        if (0 === this.queues.length) {
            this.close();

            return;
        }

        this.init();
    }

    emitOnMessageEvent(eventObject: any) {
        this.queues.forEach(q => {
            let eventData = eventObject[q.name];
            this.eventBus.$emit(`EventSourceService:${q.name}:onMessage`, eventData);
        });
    }

    connect(query: string) {
        if (this.eventSource) {
            this.close();
        }

        this.eventSource = new EventSource(this.url + '?' + query, {
            withCredentials: true
        });
    }

    close() {
        this.eventSource.close();
        this.eventSource = null;
    }

    private findQueueByName(name: String) {
        return this.queues.filter(q => q.name === name);
    }
}


// WEBPACK FOOTER //
// ./src/services/EventSourceService.ts